<form [formGroup]="formGroup">
    <div class="container-form m-t-30">
        <div class="container-form-roles">
            <div class="container-form-title m-b-10">
                {{ 'configuration-page.action-dialog.roles-assigned' | translate }}
            </div>
            <div class="container-form-body">
                <div class="container-form-body-listbox">
                    @for (rol of formGroup.get("roles")?.value; track rol) {
                    <div class="container-form-body-listbox-wrapper">
                        <!-- Properties for adding tooltips DO NOT REMOVE UNTIL NEW DEFINITION
                        [customToolTip]="getTooltip('roles', rol.id)" [tooltipStyles]="tooltipStyles" -->
                        <div class="container-form-body-listbox-wrapper-chip">
                            <fa-icon class="font-12 cursor-default" [icon]="['fal', 'check']"></fa-icon>
                            <span>{{rol.description}}</span>
                            <fa-icon class="font-15 x-mark-icon" [icon]="['fas', 'circle-xmark']"
                                (click)="removeElement('roles', rol.id)"></fa-icon>
                        </div>

                    </div>
                    }
                </div>

                <div class="dropdown-container" [ngClass]="{'m-t-15': formGroup.get('roles')?.value.length}">
                    <div class="dropdown-container-search">
                        <input id="search-rol-input" type="search"
                            [placeholder]="'common-page.custom-dropdown.search-label' | translate"
                            [(ngModel)]="searchQueryRoles"
                            [ngModelOptions]="{standalone: true}"
                            (keyup)="searchValues('rol')">
                    </div>
                    <div class="dropdown-container-content" #dropdownRoles
                        [ngClass]="{'d-none': !isDialogRolOpen, 'd-block': isDialogRolOpen}">
                        @if(rolesToSearch.length) {
                        <cdk-virtual-scroll-viewport class="dropdown-container-content-cdk" appendOnly itemSize="40px"
                            [style.height.px]="getCdkHeight('roles')">
                            @for (rol of rolesToSearch; track $index) {
                            <div [style.height]="'40px'" (click)="addElement('roles', rol.id)">
                                <div class="dropdown-container-content-cdk-item">
                                    <span class="p-l-5 cdk-item-text">
                                        {{ rol.description }}
                                    </span>
                                </div>
                            </div>
                            }

                            <!-- THE *cdkVirtualFor for some reason it generates an error
                            (unless you enter a special character in the input-search it does not render the items)
                             <div [style.height]="'40px'" *cdkVirtualFor="let rol of roles;">
                                <div class="dropdown-container-content-cdk-item">
                                    <span class="p-l-5 cdk-item-text">
                                        {{ rol.description }}
                                    </span>
                                </div>
                            </div>  -->
                        </cdk-virtual-scroll-viewport>
                        } @else {
                        <div class="dropdown-container-content-empty">
                            {{ 'common-page.custom-dropdown.empty-result-label' | translate }}

                        </div>
                        }

                    </div>
                </div>
            </div>
            @if (formGroup.get("roles")?.value.length) {
            <div class="container-form-actions">
                <button class="link" (click)="removeAllElements('roles')">
                    <fa-icon class="font-13" [icon]="['fal', 'trash-can']"></fa-icon>
                    <span> {{ 'configuration-page.action-dialog.delete-all' | translate }} </span>
                </button>
            </div>
            }

        </div>
        <div class="container-form-permissions">
            <div class="container-form-title m-b-10">
                {{ 'configuration-page.action-dialog.permissions' | translate }}
            </div>
            <div class="container-form-body">
                <div class="container-form-body-listbox">
                    @for (permission of formGroup.get("permissions")?.value; track permission) {
                    <div class="container-form-body-listbox-wrapper">
                        <!-- Properties for adding tooltips DO NOT REMOVE UNTIL NEW DEFINITION
                        [customToolTip]="getTooltip('permissions', permission.id)" [tooltipStyles]="tooltipStyles" -->
                        <div class="container-form-body-listbox-wrapper-chip"
                            [ngClass]="{'chip-disabled': verifyExistPermissionInRole(permission.id)}">
                            <fa-icon class="font-12 cursor-default" [icon]="['fal', 'check']"></fa-icon>
                            <span>{{permission.description}}</span>
                            @if(!verifyExistPermissionInRole(permission.id)) {
                            <fa-icon class="font-15 x-mark-icon" [icon]="['fas', 'circle-xmark']"
                                (click)="removeElement('permissions', permission.id)"></fa-icon>
                            }

                        </div>

                    </div>
                    }
                </div>

                <div class="dropdown-container" [ngClass]="{'m-t-15': formGroup.get('permissions')?.value.length}">
                    <div class="dropdown-container-search">
                        <input id="search-permission-input" type="search"
                            [placeholder]="'common-page.custom-dropdown.search-label' | translate"
                            [(ngModel)]="searchQueryPermissions"
                            [ngModelOptions]="{standalone: true}"
                            (keyup)="searchValues('permission')">
                    </div>
                    <div class="dropdown-container-content" #dropdownPermissions
                        [ngClass]="{'d-none': !isDialogPermissionOpen, 'd-block': isDialogPermissionOpen}">
                        @if(permissionsToSearch.length) {
                        <cdk-virtual-scroll-viewport class="dropdown-container-content-cdk" appendOnly itemSize="40px"
                            [style.height.px]="getCdkHeight('permissions')">
                            @for (permission of permissionsToSearch; track $index) {
                                <!-- Properties for adding tooltips DO NOT REMOVE UNTIL NEW DEFINITION
                                [customToolTip]="getTooltip('permissions', permission.id)" [tooltipStyles]="tooltipStyles" -->
                            <div [style.height]="'40px'" (click)="addElement('permissions', permission.id)">
                                <div class="dropdown-container-content-cdk-item">
                                    <span class="p-l-5 cdk-item-text">
                                        {{ permission.description }}
                                    </span>
                                </div>
                            </div>
                            }
                        </cdk-virtual-scroll-viewport>
                        } @else {
                        <div class="dropdown-container-content-empty">
                            {{ 'common-page.custom-dropdown.empty-result-label' | translate }}

                        </div>
                        }

                    </div>
                </div>
            </div>
            @if(permissionByUser.length) {
            <div class="container-form-actions">
                <button class="link" (click)="removeAllElements('permissions')">
                    <fa-icon class="font-13" [icon]="['fal', 'trash-can']"></fa-icon>
                    <span> {{ 'configuration-page.action-dialog.delete-all' | translate }} </span>
                </button>
            </div>
            }

        </div>
    </div>
</form>